import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ContentTreeSearchEmptyLoader: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentTreeSearchEmpty" */ '../src/ContentTreeSearchStates.tsx'
			)
		).ContentTreeSearchEmpty,
});

export const ContentTreeSearchErrorLoader: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentTreeSearchError" */ '../src/ContentTreeSearchStates.tsx'
			)
		).ContentTreeSearchError,
});
